<template>
  <div class="mx-8">
    <h1 class="mb-8 font-bold text-3xl">
      Unduh Berkas
    </h1>
    <ul class="list-disc">
      <li class="underline my-2">
        <a href="/download_files?id=template-surat-pernyataan-mhs" target="_blank">SURAT PERNYATAAN</a>
      </li>
      <li class="underline my-2">
        <a href="/download_files?id=panduan-sapbkpp" target="_blank">PANDUAN PENGGUNAAN SABPKPP VERSI DOCUMENT</a>
      </li>
      <li class="underline my-2">
        <a href="https://www.youtube.com/watch?v=9qSPL_FMbgM" target="_blank">PANDUAN PENGGUNAAN SABPKPP VERSI DESKTOP</a>
      </li>
      <li class="underline my-2">
        <a href="https://www.youtube.com/watch?v=RCRUTrFw0G8" target="_blank">PANDUAN PENGGUNAAN SABPKPP VERSI MOBILE</a>
      </li>
      <li class="underline my-2">
        <a href="https://www.youtube.com/watch?v=RBOLxHE1460" target="_blank">PANDUAN AKHIR STUDI VERSI DESKTOP</a>
      </li>
      <li class="underline my-2">
        <a href="https://www.youtube.com/watch?v=FfYiLS2EqjU" target="_blank">PANDUAN AKHIR STUDI VERSI MOBILE</a>
      </li>
    </ul>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
export default {
    metaInfo: { title: 'Files' },

    layout: Layout,
}
</script>

